function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import Overlay from '../Overlay';
import DialogTitle from './DialogTitle';
import DialogBody from './DialogBody';
import DialogFooter from './DialogFooter';
import Icon from '../Icon/Icon';
var dialogIcons = {
  error: 'exclamation-diamond',
  help: 'question-circle',
  info: 'info-circle',
  success: 'check-circle',
  warning: 'exclamation-circle'
};

var statusDialog = function statusDialog(status, property) {
  return css(["", ";"], function (_ref) {
    var theme = _ref.theme;
    return "".concat(property, ": ").concat(theme.colors[status].graphic);
  });
};

var DialogIcon = styled(Icon).attrs(function () {
  return {
    className: 'bbui-dialog-icon'
  };
}).withConfig({
  displayName: "Dialog__DialogIcon",
  componentId: "roedl3-0"
})(["font-size:", ";margin-top:18px;margin-left:8px;", " ", " ", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font.size.xlarge;
}, function (_ref3) {
  var type = _ref3.type;
  return type === 'error' && statusDialog('error', 'color');
}, function (_ref4) {
  var type = _ref4.type;
  return (type === 'info' || type === 'help') && statusDialog('info', 'color');
}, function (_ref5) {
  var type = _ref5.type;
  return type === 'success' && statusDialog('success', 'color');
}, function (_ref6) {
  var type = _ref6.type;
  return type === 'warning' && statusDialog('warning', 'color');
});
var Content = styled.div.attrs({
  className: 'bbui-dialog-content'
}).withConfig({
  displayName: "Dialog__Content",
  componentId: "roedl3-1"
})(["display:flex;flex-direction:column;"]); // attrs has to be passed a function here because we're passing a function for a prop

var ContentContainer = styled.div.attrs(function () {
  return {
    className: 'bbui-dialog-content-container',
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  };
}).withConfig({
  displayName: "Dialog__ContentContainer",
  componentId: "roedl3-2"
})(["display:flex;flex-direction:row;border-top:8px solid transparent;", " ", " ", " ", " ", " ", ""], function (_ref7) {
  var width = _ref7.width;
  return width ? "width: ".concat(width, ";") : 'max-width: 640px;';
}, function (_ref8) {
  var height = _ref8.height;
  return height ? "height: ".concat(height, ";") : '';
}, function (_ref9) {
  var type = _ref9.type;
  return type === 'error' && statusDialog('error', 'border-color');
}, function (_ref10) {
  var type = _ref10.type;
  return (type === 'info' || type === 'help') && statusDialog('info', 'border-color');
}, function (_ref11) {
  var type = _ref11.type;
  return type === 'success' && statusDialog('success', 'border-color');
}, function (_ref12) {
  var type = _ref12.type;
  return type === 'warning' && statusDialog('warning', 'border-color');
});
export var Dialog = function Dialog(props) {
  var children = props.children,
      className = props.className,
      type = props.type,
      width = props.width,
      height = props.height,
      rest = _objectWithoutProperties(props, ["children", "className", "type", "width", "height"]);

  var name = type ? dialogIcons[type] : '';
  return React.createElement(Overlay, _extends({
    className: "bbui-dialog ".concat(className),
    showShadow: false,
    depth: 1
  }, rest), React.createElement(ContentContainer, {
    type: type,
    width: width,
    height: height
  }, type && name && React.createElement(DialogIcon, {
    type: type,
    name: name
  }), React.createElement(Content, null, children)));
};
Dialog.Footer = DialogFooter;
Dialog.Title = DialogTitle;
Dialog.Body = DialogBody;
Dialog.defaultProps = {
  className: '',
  closeOnOverlayClick: true,
  closeOnEscKey: true,
  isOpen: false,
  type: undefined
};
export default Dialog;